import React from "react";
import { MDBContainer, MDBNavbar, MDBNavbarBrand } from "mdb-react-ui-kit";
import Logo from "../img/logo.png";

function Header() {
  return (
    <header>
      <MDBNavbar expand="lg" className="bg-color6 mb-4 py-0">
        <MDBContainer fluid>
          <MDBNavbarBrand href="/" tag="a" className="mb-0 text-white">
            <img width="50px" src={Logo}></img>
            <span className="d-none d-lg-block">
              Montana Legislative Services
            </span>
            <span className="d-lg-none">MT Legislative</span>
          </MDBNavbarBrand>
        </MDBContainer>
      </MDBNavbar>
    </header>
  );
}

export default Header;
